const translate = window.INKIVE?.TranslateHelper?.translate || (key => key);
export default translate;
